<kpd-side-panel [facade]="licenseFacade" [entityName]="'License' | translate" (itemChanged)="onItemChange($event)">
  <ng-template kpdTemplate="actionbar" let-selection let-loading="loading" let-deleted="deleted">
    <kpd-action-consult-overview
      *ngIf="selection.length !== 0 && !deleted"
      (action)="onView(selection[0])"
      [disable]="loading"
    ></kpd-action-consult-overview>
  </ng-template>

  <ng-template kpdTemplate="singleItem" let-item>
    <h3 translate>General</h3>
    <div class="flex-row flex-wrap">
      <div class="flex-column">
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Name</label>
          <label class="value">{{ item.getDisplayName() | kpdDefault }}</label>
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Amount</label>
          <label class="value">{{ item.quantity | kpdDefault }}</label>
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Used</label>
          <label class="value">{{ item.quantityAssigned | kpdDefault }}</label>
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Validity</label>
          <label class="value"
            >{{ item.validFromDateTime | localeDate }} - {{ item.validUntilDateTime | localeDate }}</label
          >
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Acquired</label>
          <label class="value">{{ item.purchaseDateTime | localeDate | kpdDefault }}</label>
        </div>
        <div class="read-group flex-row read-sidepannel">
          <label class="title" translate>Applications</label>
          <div class="flex-column">
            <label class="value m-bottom-5" *ngFor="let application of item.applications">{{
              application?.name
            }}</label>
          </div>
        </div>
      </div>
    </div>
    <ng-container *kpdPermission="Permissions.UserRead">
      <h3 translate>Users</h3>
      <div *ngIf="!usersLoading && (!licenseUsers || licenseUsers.length === 0)" translate>No users assigned</div>
      <div class="flex-row flex-wrap relative">
        <kpd-spinner *ngIf="usersLoading" type="overlay"></kpd-spinner>
        <ul *ngIf="!usersLoading" class="full-width">
          <li *ngFor="let user of licenseUsers" class="list-item">{{ user.getDisplayName() | kpdDefault }}</li>
        </ul>
      </div>
    </ng-container>
  </ng-template>

  <ng-template kpdTemplate="multiItem" let-item>
    <div class="card-small">
      <label class="card__header">
        <span class="card__multival flex-row">
          <div class="code">{{ item.applicationNames | kpdDefault }}</div>
          <div class="name">{{ item.getDisplayName() | kpdDefault }}</div>
        </span>
      </label>
    </div>
  </ng-template>

  <ng-template kpdTemplate="tiles" let-item *kpdPermission="Permissions.UserRead">
    <kpd-tile
      icon="user"
      [title]="'Users' | translate"
      [value]="item.quantityAssigned"
      (click)="navigateToUsers(item.key)"
    ></kpd-tile>
  </ng-template>
  <kpd-side-panel> </kpd-side-panel
></kpd-side-panel>
